import { KeyframeConfig } from "../../../models/animations.model";
import { ObjectMeasures } from "../../../models/canvas.model";

export const getFlyInTopBaseKeyframe = (
  objectMeasures: ObjectMeasures,
  canvasMeasures: ObjectMeasures
): KeyframeConfig[] => {
  return [
    {
      option: {
        keyframes: [
          {
            left: objectMeasures.left,
            top: objectMeasures.top - canvasMeasures.height,
          },
          {
            left: objectMeasures.left,
            top: objectMeasures.top,
          },
        ],
      },
    },
  ];
};

export const getFlyInBottomBaseKeyframe = (
  objectMeasures: ObjectMeasures,
  canvasMeasures: ObjectMeasures
): KeyframeConfig[] => {
  return [
    {
      option: {
        keyframes: [
          {
            left: objectMeasures.left,
            top: objectMeasures.top + canvasMeasures.height,
          },
          {
            left: objectMeasures.left,
            top: objectMeasures.top,
          },
        ],
      },
    },
  ];
};

export const getFlyInLeftBaseKeyframe = (
  objectMeasures: ObjectMeasures,
  canvasMeasures: ObjectMeasures
): KeyframeConfig[] => {
  return [
    {
      option: {
        keyframes: [
          {
            left: objectMeasures.left - canvasMeasures.width,
            top: objectMeasures.top,
          },
          {
            left: objectMeasures.left,
            top: objectMeasures.top,
          },
        ],
      },
    },
  ];
};

export const getFlyInRightBaseKeyframe = (
  objectMeasures: ObjectMeasures,
  canvasMeasures: ObjectMeasures
): KeyframeConfig[] => {
  return [
    {
      option: {
        keyframes: [
          {
            left: objectMeasures.left + canvasMeasures.width,
            top: objectMeasures.top,
          },
          {
            left: objectMeasures.left,
            top: objectMeasures.top,
          },
        ],
      },
    },
  ];
};

export const getFlyOutTopBaseKeyframe = (
  objectMeasures: ObjectMeasures,
  canvasMeasures: ObjectMeasures
): KeyframeConfig[] => {
  return [
    {
      option: {
        keyframes: [
          {
            left: objectMeasures.left,
            top: objectMeasures.top,
          },
          {
            left: objectMeasures.left,
            top: objectMeasures.top - canvasMeasures.height,
          },
        ],
      },
    },
  ];
};

export const getFlyOutBottomBaseKeyframe = (
  objectMeasures: ObjectMeasures,
  canvasMeasures: ObjectMeasures
): KeyframeConfig[] => {
  return [
    {
      option: {
        keyframes: [
          {
            left: objectMeasures.left,
            top: objectMeasures.top,
          },
          {
            left: objectMeasures.left,
            top: objectMeasures.top + canvasMeasures.height,
          },
        ],
      },
    },
  ];
};

export const getFlyOutLeftBaseKeyframe = (
  objectMeasures: ObjectMeasures,
  canvasMeasures: ObjectMeasures
): KeyframeConfig[] => {
  return [
    {
      option: {
        keyframes: [
          {
            left: objectMeasures.left,
            top: objectMeasures.top,
          },
          {
            left: objectMeasures.left - canvasMeasures.width,
            top: objectMeasures.top,
          },
        ],
      },
    },
  ];
};

export const getFlyOutRightBaseKeyframe = (
  objectMeasures: ObjectMeasures,
  canvasMeasures: ObjectMeasures
): KeyframeConfig[] => {
  return [
    {
      option: {
        keyframes: [
          {
            left: objectMeasures.left,
            top: objectMeasures.top,
          },
          {
            left: objectMeasures.left + canvasMeasures.width,
            top: objectMeasures.top,
          },
        ],
      },
    },
  ];
};
